module.exports = __webpack_public_path__ + "static/media/adventure-archive-screenshot-6.1eed5b1f.jpg";